import React from "react";
import { Link } from "react-router-dom";

const EventActionCard = React.memo(
  ({
    title,
    description,
    to,
    onClick,
    iconSrc,
    iconAlt,
    disabledIcon,
    disabledAlt,
    isDisabled = false,
    hideClasses = false,
    classes = "",
  }) => {
    const handleClick = React.useCallback(
      (e) => {
        if (isDisabled) {
          e.preventDefault();
          return;
        }
        if (onClick) {
          onClick(e);
        }
      },
      [isDisabled, onClick]
    );

    const cardClasses = `${classes} d-flex flex-column align-items-center justify-content-center ${
      !hideClasses ? "event-action-card p-3 m-3" : ""
    }`;

    const cardContent = (
      <>
        <figure className="text-center">
          <img
            src={isDisabled ? disabledIcon : iconSrc}
            alt={isDisabled ? disabledAlt : iconAlt}
            className={isDisabled ? "disabled-icon" : ""}
          />
        </figure>
        <h6 className="event-action-card-title">{title}</h6>
        <p className="event-action-card-description m-0">{description}</p>
      </>
    );

    if (isDisabled) {
      return <div className={cardClasses}>{cardContent}</div>;
    }

    if (to) {
      return (
        <Link
          to={to}
          onClick={handleClick}
          className={`${cardClasses} text-decoration-none`}
        >
          {cardContent}
        </Link>
      );
    }

    return (
      <button
        type="button"
        onClick={handleClick}
        className={`${cardClasses} ghost-btn`}
      >
        {cardContent}
      </button>
    );
  }
);

EventActionCard.displayName = "EventActionCard";
export default EventActionCard;
